import { useEffect } from 'react';
import { useSnapshot } from 'valtio';

import * as updatedProductStore from '@cartwhl/common/stores/updatedProductStore';
import * as userStore from '@cartwhl/common/stores/userStore';
import {
  isActiveFreeTrial,
  isOrgCreditsWorkspace,
} from '@cartwhl/common/utils/organizationWorkspace';

import ActivateEarlyTrialModal from './ActivateEarlyTrialModal';

/**
 * Mount once per app (e.g. next to `PurchaseCreditsModalHost`) so
 * `openActivateEarlyTrialModal` can open the UI from anywhere.
 */
export default function ActivateEarlyTrialModalHost() {
  const snap = useSnapshot(updatedProductStore.activateEarlyTrialModalState);
  const { organizationInfo } = useSnapshot(userStore.state);
  const inOrgCreditsTrial =
    isOrgCreditsWorkspace(organizationInfo) &&
    isActiveFreeTrial(organizationInfo);

  useEffect(() => {
    if (!inOrgCreditsTrial) {
      updatedProductStore.closeActivateEarlyTrialModal();
    }
  }, [inOrgCreditsTrial]);

  if (!snap.isOpen || !inOrgCreditsTrial) {
    return null;
  }
  return (
    <ActivateEarlyTrialModal
      close={updatedProductStore.closeActivateEarlyTrialModal}
    />
  );
}
